import React from 'react';
import PropTypes from 'prop-types';

import { makeAccordionObj } from '../../Utils/ProductUtils';

import ProductAccordionItem from './ProductAccordionItem';

import { StyledAccordionRow } from './ProductAccordionStyles';

var ProductAccordion = function ProductAccordion(_ref) {
  var product = _ref.product,
      selectedVariant = _ref.selectedVariant,
      shippingTimes = _ref.shippingTimes,
      pdpReturnCopy = _ref.pdpReturnCopy,
      shippingSurcharge = _ref.shippingSurcharge;

  var accordionArr = makeAccordionObj(product, selectedVariant, shippingTimes, pdpReturnCopy, shippingSurcharge);

  return React.createElement(
    StyledAccordionRow,
    null,
    accordionArr.map(function (cat, ind) {
      var content = cat.content.map(function (c, i) {
        return cat.title === 'Policies' ? React.createElement(
          'p',
          { key: cat.title + ' - Content ' + i },
          c
        ) : cat.title === 'Care' && i === 1 ? React.createElement(
          'a',
          { key: cat.title + ' - Content ' + i, href: '/pages/care#' + c },
          'Additional Instructions'
        ) : c + ' ';
      });
      return React.createElement(ProductAccordionItem, {
        key: '' + cat.title,
        cat: cat,
        content: content,
        defaultOpen: ind === 0
      });
    })
  );
};

ProductAccordion.propTypes = {
  customReturnPolicy: PropTypes.object,
  tags: PropTypes.array.isRequired,
  vendor: PropTypes.string.isRequired,
  shipLaterEnabled: PropTypes.bool,
  preorderDate: PropTypes.object,
  pdpAccordionBnslCopy: PropTypes.string,
  pdpReturnCopy: PropTypes.string,
  shippingTimes: PropTypes.object,
  product: PropTypes.object,
  selectedVariant: PropTypes.object,
  shippingSurcharge: PropTypes.bool
};

export default ProductAccordion;